module.exports = __webpack_public_path__ + "1f9a779799f594c502dc6221bcfc6cc8.jpg";